import { TypedUseSelectorHook, useDispatch, useSelector, shallowEqual } from 'react-redux';
import { RootState, AppDispatch } from '@/store/index';
// import store from '@/store/index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// export const useAppDispatch: () => AppDispatch = useDispatch<AppDispatch>();
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
// memoried state
export const useAppShallowEqualSelector: TypedUseSelectorHook<RootState> = (state:any) => useSelector(state,shallowEqual)